import {
    REQUEST_SYSTEM_LOG,
    REQUEST_SYSTEM_LOG_SUCCESS,
    REQUEST_SYSTEM_LOG_FAILURE
} from "../../constant/other/SystemLogConstant";

const initialState = {
    systemLog: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const systemLogReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_SYSTEM_LOG:
            return {
                ...state,
                systemLog: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_SYSTEM_LOG_SUCCESS:
            return {
                ...state,
                systemLog: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_SYSTEM_LOG_FAILURE:
            return {
                ...state,
                systemLog: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
